export const gbp = (n, dp = 0) =>
  `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: dp, maximumFractionDigits: dp })}`;

export const pct = (n, dp = 0) => `${Number(n || 0).toFixed(dp)}%`;

export const FULL_MONTHS = {
  Jan: "January", Feb: "February", Mar: "March", Apr: "April", May: "May", Jun: "June",
  Jul: "July", Aug: "August", Sep: "September", Oct: "October", Nov: "November", Dec: "December",
};

export function esc(s) {
  return String(s ?? "");
}